(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-tiles"]) return;
  try {
    
  document.querySelectorAll('[data-tiles-bar]').forEach(function (bar) {
    var sort = bar.querySelector('[data-tiles-sort]');
    if (sort) sort.addEventListener('change', function () { bar.submit(); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram-feed"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SPEED = 56;
    const wake = (root) => {
      for (const img of root.querySelectorAll('img[data-src]')) {
        img.srcset = img.dataset.srcset;
        img.src = img.dataset.src;
        img.removeAttribute('data-srcset');
        img.removeAttribute('data-src');
      }
    };
    const setup = (root) => {
      if (root.dataset.igfReady) return;
      root.dataset.igfReady = '1';
      for (const copy of root.querySelectorAll('[data-igf-copy] [data-igf-tab]')) copy.tabIndex = -1;
      const cycle = root.querySelector('.igf__cycle');
      const time = () => {
        const w = cycle.getBoundingClientRect().width;
        if (w) root.style.setProperty('--igf-time', `${(w / SPEED).toFixed(2)}s`);
      };
      time();
      if ('ResizeObserver' in window) new ResizeObserver(time).observe(cycle);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(([e]) => root.classList.toggle('is-off', !e.isIntersecting)).observe(root);
      }
    };
    const run = (scope) => scope.querySelectorAll('[data-igf]').forEach(setup);
    run(document);
    document.addEventListener('shopify:section:load', (e) => {
      run(e.target);
      wake(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-pt-tab]');
    if (!tab) return;
    var root = tab.closest('.pt');
    if (!root) return;
    root.querySelectorAll('[data-pt-tab]').forEach(function (t) {
      var on = t === tab;
      t.classList.toggle('is-on', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    root.querySelectorAll('[data-pt-panel]').forEach(function (p) {
      p.hidden = p.id !== tab.getAttribute('aria-controls');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["profile-strip"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SPEED = 40;
    const setup = (root) => {
      if (root.dataset.pplReady) return;
      root.dataset.pplReady = '1';
      for (const img of root.querySelectorAll('[data-ppl-pic]')) {
        const miss = () => img.classList.add('is-missing');
        if (img.complete && img.naturalWidth === 0 && img.currentSrc) miss();
        else img.addEventListener('error', miss, { once: true });
      }
      const group = root.querySelector('.ppl__group');
      if (!group) return;
      const time = () => {
        const w = group.getBoundingClientRect().width;
        if (w) root.style.setProperty('--ppl-time', `${(w / SPEED).toFixed(2)}s`);
      };
      time();
      if ('ResizeObserver' in window) new ResizeObserver(time).observe(group);
    };
    const run = (scope) => scope.querySelectorAll('[data-ppl]').forEach(setup);
    run(document);
    document.addEventListener('shopify:section:load', (e) => run(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  /* Sorting and the reveal both work on cards that are already in the HTML.
     Nothing is fetched and no review text is written by script, so the wall a
     crawler reads is the wall a customer reads.

     Featured orders rather than filters: photo reviews lead, text reviews
     follow, and the reveal walks from one into the other. Array sort is stable,
     so the corpus order survives inside each of the two groups. */
  class ReviewWall extends HTMLElement {
    connectedCallback() {
      this.wall = this.querySelector('[data-rv-wall]');
      if (!this.wall) return;
      this.cards = Array.from(this.wall.children);
      this.order = this.cards.slice();
      this.step = parseInt(this.wall.style.getPropertyValue('--rv-visible'), 10) || 12;
      this.limit = this.step;
      this.busy = false;

      this.moreWrap = this.querySelector('[data-rv-more-wrap]');
      this.more = this.querySelector('[data-rv-more]');
      this.moreLabel = this.querySelector('[data-rv-more-label]');
      if (this.moreWrap) this.moreWrap.hidden = false;
      if (this.more) this.more.addEventListener('click', () => this.press());

      const sort = this.querySelector('[data-rv-sort]');
      if (sort) {
        sort.addEventListener('change', () => {
          this.limit = this.step;
          this.rearm();
          this.apply(sort.value);
        });
      }
      this.apply(sort ? sort.value : 'recent');
    }

    apply(mode) {
      const list = this.order.slice();
      if (mode === 'rating') {
        list.sort((a, b) => b.dataset.rating - a.dataset.rating);
      } else if (mode === 'media') {
        /* Photo reviews lead, but the first N of them are the ones the
           carousel higher up the page has already shown. Those go after the
           photo reviews a visitor has not seen yet, so the wall opens with
           something new rather than a repeat. */
        const above = parseInt(this.wall.dataset.rvShownAbove, 10) || 0;
        const names = (this.wall.dataset.rvShownNames || '').split(',').map((n) => n.trim()).filter(Boolean);
        const nameOf = (c) => { const el = c.querySelector('.rvc__name'); return el ? el.textContent.trim() : ''; };
        const media = list.filter((c) => c.dataset.media === '1');
        const text = list.filter((c) => c.dataset.media !== '1');
        const seen = (c, i) => i < above || names.includes(nameOf(c));
        list.length = 0;
        list.push(...media.filter((c, i) => !seen(c, i)), ...media.filter(seen), ...text);
      }
      list.forEach((c) => this.wall.appendChild(c));
      this.cards = list;
      this.paint();
    }

    paint() {
      this.cards.forEach((c, i) => { c.hidden = i >= this.limit; });
    }

    /* A re-sort starts the reveal over, so the button has to come back to its
       resting label whatever state the last press left it in. */
    rearm() {
      if (!this.more) return;
      clearTimeout(this.timer);
      this.busy = false;
      this.more.classList.remove('is-loading', 'is-error');
      this.more.removeAttribute('aria-busy');
      this.moreLabel.textContent = this.more.dataset.labelDefault;
    }

    press() {
      if (this.busy || !this.more) return;
      if (this.limit < this.cards.length) {
        this.limit += this.step;
        this.paint();
        return;
      }
      this.busy = true;
      this.more.classList.remove('is-error');
      this.more.classList.add('is-loading');
      this.more.setAttribute('aria-busy', 'true');
      this.moreLabel.textContent = this.more.dataset.labelLoading;
      this.timer = setTimeout(() => {
        this.busy = false;
        this.more.classList.remove('is-loading');
        this.more.removeAttribute('aria-busy');
        this.more.classList.add('is-error');
        this.moreLabel.textContent = this.more.dataset.labelError;
      }, 1400);
    }
  }
  if (!customElements.get('review-wall')) customElements.define('review-wall', ReviewWall);

  } catch(e) { console.error(e); }
})();
})();
